 const jobs = [
   {
     title: 'Medical Technician',
     start: '2015',
     end: '',
     description: [
       'Database administrator for psychological services in Singapore Prisons',
       'Internal team for Wordpress website maintenance – plugin, updates and error management',
       'Technical Lead for team to create an academy for addiction treatment',
       'Initiated the use of Google Scripts to automate high volume repetitive actions such as reminders and certificate creation',
       'Manage IT vendors and internal IT requirements'
     ]
   },
   {
     title: 'Retail Assistant',
     start: '2013',
     end: '2015',
     description: ['Working with the store’s inventory and transactional database before a POS system was bought']
    },
    {
     title: 'Retail Trading',
     start: '2007',
     end: '2010',
     description: ['Traded derivatives for family funds.']
    },
  ]

export default jobs;
